import { Heading, VStack } from '@chakra-ui/react'

import { isAllowlistedForATS } from '@/helpers/is-allowlisted'
import { useUser } from '@/react-query/user'

import { ATSIntegration } from './ATS/ATSIntegration'
import { DeleteOldInterviews } from './DeleteOldInterviews'
import { TeamVideoRecording } from './TeamVideoRecording'
import { TeamVisibility } from './TeamVisibility'

export const TeamSettings = () => {
  const { data: user } = useUser()

  return (
    <VStack spacing={10} mt={20} alignItems={'flex-start'}>
      <Heading fontSize="2xl" fontWeight="bold">
        Team-wide settings
      </Heading>
      <TeamVisibility />
      <TeamVideoRecording />
      <DeleteOldInterviews />
      {isAllowlistedForATS(user?.email) && <ATSIntegration />}
    </VStack>
  )
}
